import { httpClient, httpClientUrlStringBuilder } from '@/network/clientController'

/** Gets all Operations Types List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationstypes
*/
export const getOperationsTypesList = payload => {
	return httpClient({
		method: 'GET',
		url: 'operations/types',
		params: payload,
		isCancellable: true
	})
}

/** Gets all Operations Status List
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationsstatus
*/
export const getOperationsStatusList = payload => {
	return httpClient({
		method: 'GET',
		url: 'operations/status',
		isCancellable: true
	})
}

/** Gets Operations history Tabs list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationshistorytabs
*/
export const getOperationHistoryTabsList = payload => {
	return httpClient({
		method: 'GET',
		url: 'operations/history/tabs',
		isCancellable: true
	})
}

/** Gets Operations history list
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operations
*/
export const getOperationHistoryList = payload => {
	return httpClient({
		method: 'GET',
		url: 'operations',
		params: payload,
		isCancellable: true
	})
}

/** Cancels Operation
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/DELETE_operations
*/
export const cancelOperation = payload => {
	return httpClient({
		method: 'DELETE',
		url: 'operations',
		params: payload
	})
}

/** Gets Operation Generic Detail
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationsdetails_
*/
export const getOperationGenericDetail = payload => {
	return httpClient({
		method: 'GET',
		url: 'operations/details',
		params: payload,
		isCancellable: true
	})
}

/** Generate a link to share a pdf without the need to send the file
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_operationsgenerateLink_
*/
export const generateShareLink = payload => {
	return httpClient({
		method: 'POST',
		url: 'operations/generateLink',
        params: payload.params,
		data: payload.data
	})
}

/** Creates the url to download generic operation receipt/exctrat pdf
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operationsgenerateReceipt
*/
export const createDownloadGenericReceiptPdf = payload => {
	return httpClientUrlStringBuilder({
		method: 'GET',
		url: 'operations/generateReceipt',
		params: payload.params
	})
}

/** Sends a notification to email
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_operations%7Bid%7Dnotificationemail_
*/
export const sendOperationEmailNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `operations/${payload.operationId}/notification/email`,
		data: payload.data
	})
}

/** Sends a notification to sms
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_operations%7Bid%7Dnotificationsms_
*/
export const sendOperationSMSNotification = payload => {
	return httpClient({
		method: 'POST',
		url: `operations/${payload.operationId}/notification/sms`,
		data: payload.data
	})
}

/** Sends multiple operations info notification to email
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_operationsnotificationsemail_
*/
export const sendBulkOperationEmailNotification = payload => {
	return httpClient({
		method: 'POST',
		url: 'operations/notifications/email',
		data: payload.data
	})
}

/** Sends multiple operations info notification to sms
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/POST_operationsnotificationssms_
*/
export const sendBulkOperationSMSNotification = payload => {
	return httpClient({
		method: 'POST',
		url: 'operations/notifications/sms',
		data: payload.data
	})
}

/** Requests smart transfers details
@docs https://issue.inm.pt/projects/c04401-banco-mais-middleware-integracao/wiki/GET_operations%7Bid%7Dgeneric_
*/
export const getSmartTransfersDetails = payload => {
	return httpClient({
		method: 'GET',
		url: `operations/${payload}/generic`
	})
}
